export class ArchivoProducto {
    constructor(
        public IdArchivo: number | string = null,
        public src: string = '', // url del archivo en (base 64)
        public nombreWeb: string = '',
        public orden: number = null, // orden del archivo en un grupo de archivos
        public nombre: string = '' // nombre del archivo
    ) { }
}